import "./style.css";

export default class FileUpload {
  static selector = ".file-upload";

  constructor(block) {
    this.block = block;
    this.label = this.block.querySelector(".file-upload__label span");
  }

  handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];
    this.label.innerText = selectedFile.name;
  };

  onReady() {
    this.block.addEventListener("change", this.handleFileUpload);
  }

  onResize() {}

  onDestroy() {
    this.block.removeEventListener("change", this.handleFileUpload);
  }
}
